<template>
  <div class=" " >
    <v-main>
      <div class="head px-4" >
        <h1 style="color:#fff">sdsd</h1>
        <div class="hero ">
          <h1>sada</h1>
        </div>
      </div>
    </v-main>
  </div>
</template>

<script>
export default {

  data () {
    return {
      session: this.$session.getAll()

    }
  },

  mounted () {

  },

  methods: {

  }
}
</script>

<style scoped>
.head {
  background-color: #25388D;
  height: 100vh;
}
.hero {
  background-color: #fff;
  border: 2px solid #fff;
  border-radius: 25px;
  height: 94vh;
}

</style>



// WEBPACK FOOTER //
// src/components/Master/Blog.vue